module.exports = __webpack_public_path__ + "media/images/logo-simple-0d7a6a99e7cd9bf8a42ecbca88081327.svg";